<template>
  <div v-show="isActive" class="widgetContainer" id="locatorID">
    <div class="map-tool-window-header" id="locatorIDheader">
      <p class="map-tool-window-header-title">Localizador</p>
      <div class="map-tool-window-header-actions">
        <button class="control-btn" @click="exitLocator()">
          <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
          <!-- <font-awesome-icon icon="times"></font-awesome-icon> -->
        </button>
      </div>
    </div>

    <div class="widgetBody">
      <div class="locator-sections">
        <!-- SECCIÓN COORDENADAS -->
        <div class="section-container">
          <div class="section-header" @click="toggleSection('coords')">
            <span>Coordenadas</span>
            <font-awesome-icon :icon="sections.coords ? 'chevron-up' : 'chevron-down'" />
          </div>
          
          <div v-show="sections.coords" class="section-content">
            <!-- PESTAÑAS (Usando divs para evitar estilos de lista globales) -->
            <div class="tabs-container">
              <div class="tab-item" :class="{ active: activeTab === 'decimal' }" @click="activeTab = 'decimal'">Decimal</div>
              <!--Observacion SENAPRED 06/2026 ("Cambiar Utm a UTM")-->
              <div class="tab-item" :class="{ active: activeTab === 'utm' }" @click="activeTab = 'utm'">UTM</div>
              <div class="tab-item" :class="{ active: activeTab === 'gms' }" @click="activeTab = 'gms'">GMS</div>
            </div>

            <!-- CONTENIDO PESTAÑAS -->
            <div class="tab-pane-content">
              <!-- DECIMAL -->
              <div v-show="activeTab === 'decimal'" class="decimal-form">
                <div class="input-row">
                  <div class="input-group">
                    <label>Longitud:</label>
                    <input type="number" v-model.number="coords.decimal.lon" placeholder="Ej.: -70.639081">
                  </div>
                  <div class="input-group">
                    <label>Latitud:</label>
                    <input type="number" v-model.number="coords.decimal.lat" placeholder="Ej.: -33.453103">
                  </div>
                </div>
                <div class="button-center">
                  <button class="btn btn-primary btn-localizar" @click="localizeDecimal">
                    <font-awesome-icon icon="location-arrow" /> Localizar
                  </button>
                </div>
              </div>

              <!-- UTM -->
              <div v-show="activeTab === 'utm'" class="utm-form">
                <div class="input-row">
                  <!--Observacion SENAPRED 06/2026 ("en la sección UTM cambiar X por Este e Y por Norte")-->
                  <div class="input-group">
                    <label>Este:</label>
                    <input type="number" v-model.number="coords.utm.x" placeholder="Ej.: 347663">
                  </div>
                  <div class="input-group">
                    <label>Norte:</label>
                    <input type="number" v-model.number="coords.utm.y" placeholder="Ej.: 6297278">
                  </div>
                  <div class="input-group zona-input">
                    <label>Zona:</label>
                    <input type="number" v-model.number="coords.utm.zona" placeholder="Ej.: 19">
                  </div>
                </div>
                <div class="hemisphere-selector mb-3">
                  <label class="mr-2">Hemisferio:</label>
                  <div class="btn-group">
                    <button class="btn btn-sm" :class="coords.utm.hemisferio === 'N' ? 'btn-primary' : 'btn-outline-primary'" @click="coords.utm.hemisferio = 'N'">Norte</button>
                    <button class="btn btn-sm" :class="coords.utm.hemisferio === 'S' ? 'btn-primary' : 'btn-outline-primary'" @click="coords.utm.hemisferio = 'S'">Sur</button>
                  </div>
                </div>
                <div class="button-center">
                  <button class="btn btn-primary btn-localizar" @click="localizeUtm">
                    <font-awesome-icon icon="location-arrow" /> Localizar
                  </button>
                </div>
              </div>

              <!-- GMS -->
              <div v-show="activeTab === 'gms'" class="gms-form">
                <div class="gms-section">
                  <label class="section-label">Latitud:</label>
                  <div class="input-row gms-row">
                    <div class="input-group mini">
                      <label>G</label>
                      <input type="number" v-model.number="coords.gms.lat.g" placeholder="33">
                    </div>
                    <div class="input-group mini">
                      <label>M</label>
                      <input type="number" v-model.number="coords.gms.lat.m" placeholder="26">
                    </div>
                    <div class="input-group mini">
                      <label>S</label>
                      <input type="number" v-model.number="coords.gms.lat.s" placeholder="16.19">
                    </div>
                    <div class="input-group h-toggle">
                      <label>H</label>
                      <div class="btn-group-vertical h-btn-group">
                        <button class="btn btn-xs" :class="coords.gms.lat.h === 'N' ? 'btn-primary' : 'btn-outline-primary'" @click="coords.gms.lat.h = 'N'">N</button>
                        <button class="btn btn-xs" :class="coords.gms.lat.h === 'S' ? 'btn-primary' : 'btn-outline-primary'" @click="coords.gms.lat.h = 'S'">S</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="gms-section mt-2">
                  <label class="section-label">Longitud:</label>
                  <div class="input-row gms-row">
                    <div class="input-group mini">
                      <label>G</label>
                      <input type="number" v-model.number="coords.gms.lon.g" placeholder="70">
                    </div>
                    <div class="input-group mini">
                      <label>M</label>
                      <input type="number" v-model.number="coords.gms.lon.m" placeholder="39">
                    </div>
                    <div class="input-group mini">
                      <label>S</label>
                      <input type="number" v-model.number="coords.gms.lon.s" placeholder="1.61">
                    </div>
                    <div class="input-group h-toggle">
                      <label>H</label>
                      <div class="btn-group-vertical h-btn-group">
                        <button class="btn btn-xs" :class="coords.gms.lon.h === 'E' ? 'btn-primary' : 'btn-outline-primary'" @click="coords.gms.lon.h = 'E'">E</button>
                        <button class="btn btn-xs" :class="coords.gms.lon.h === 'O' ? 'btn-primary' : 'btn-outline-primary'" @click="coords.gms.lon.h = 'O'">O</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="button-center mt-3">
                  <button class="btn btn-primary btn-localizar" @click="localizeGms">
                    <font-awesome-icon icon="location-arrow" /> Localizar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SECCIÓN REGIONAL -->
        <div class="section-container mt-2">
          <div class="section-header" @click="toggleSection('regional')">
            <span>Regional</span>
            <font-awesome-icon :icon="sections.regional ? 'chevron-up' : 'chevron-down'" />
          </div>
          <div v-show="sections.regional" class="section-content p-3 overflow-hidden">
            <div class="regional-form">
              <!-- REGIÓN -->
              <div class="regional-row">
                <label>
                  Regiones
                  <font-awesome-icon v-if="regional.loading.regions" icon="spinner" spin class="ml-1 text-primary" />
                </label>
                <div class="input-and-btn">
                  <select v-model="regional.selected.region" @change="onRegionChange" class="custom-select-small" :disabled="regional.loading.regions">
                    <option :value="null">{{ regional.loading.regions ? 'Cargando regiones...' : 'Seleccione Región' }}</option>
                    <option v-for="r in regional.regions" :key="r.cine_reg" :value="r.cine_reg">{{ r.nom_reg }}</option>
                  </select>
                  <button class="btn btn-primary btn-ir" @click="goToRegional(1, regional.selected.region, 'cine_reg')" :disabled="!regional.selected.region || regional.loading.regions">
                    <font-awesome-icon icon="location-arrow" /> Ir
                  </button>
                </div>
              </div>

              <!-- PROVINCIA -->
              <div class="regional-row mt-2">
                <label>
                  Provincia
                  <font-awesome-icon v-if="regional.loading.provinces" icon="spinner" spin class="ml-1 text-primary" />
                </label>
                <div class="input-and-btn">
                  <select v-model="regional.selected.province" @change="onProvinceChange" class="custom-select-small" :disabled="regional.loading.provinces || !regional.selected.region">
                    <option :value="null">{{ regional.loading.provinces ? 'Cargando provincias...' : 'Seleccione Provincia' }}</option>
                    <option v-for="p in regional.provinces" :key="p.cine_prov" :value="p.cine_prov">{{ p.nom_prov }}</option>
                  </select>
                  <button class="btn btn-primary btn-ir" @click="goToRegional(2, regional.selected.province, 'cine_prov')" :disabled="!regional.selected.province || regional.loading.provinces">
                    <font-awesome-icon icon="location-arrow" /> Ir
                  </button>
                </div>
              </div>

              <!-- COMUNA -->
              <div class="regional-row mt-2">
                <label>
                  Comunas
                  <font-awesome-icon v-if="regional.loading.communes" icon="spinner" spin class="ml-1 text-primary" />
                </label>
                <div class="input-and-btn">
                  <select v-model="regional.selected.commune" @change="onCommuneChange" class="custom-select-small" :disabled="regional.loading.communes || !regional.selected.province">
                    <option :value="null">{{ regional.loading.communes ? 'Cargando comunas...' : 'Seleccione Comuna' }}</option>
                    <option v-for="c in regional.communes" :key="c.cine_com" :value="c.cine_com">{{ c.nom_com }}</option>
                  </select>
                  <button class="btn btn-primary btn-ir" @click="goToRegional(3, regional.selected.commune, 'cine_com')" :disabled="!regional.selected.commune || regional.loading.communes">
                    <font-awesome-icon icon="location-arrow" /> Ir
                  </button>
                </div>
              </div>

              <!-- ENTIDADES -->
              <div class="regional-row mt-2">
                <label>
                  Entidades
                  <font-awesome-icon v-if="regional.loading.entities" icon="spinner" spin class="ml-1 text-primary" />
                </label>
                <div class="input-and-btn">
                  <select v-model="regional.selected.entity" class="custom-select-small" :disabled="regional.loading.entities || !regional.selected.commune">
                    <option :value="null">{{ regional.loading.entities ? 'Cargando entidades...' : '[Seleccione Entidad]' }}</option>
                    <option v-for="e in regional.entities" :key="e.objectid_1" :value="e.objectid_1">{{ e.nom_ent }}</option>
                  </select>
                  <button class="btn btn-primary btn-ir" @click="goToRegional(0, regional.selected.entity, 'objectid_1')" :disabled="!regional.selected.entity || regional.loading.entities">
                    <font-awesome-icon icon="location-arrow" /> Ir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { draggableDiv } from '@/components/mixin/draggableDiv.js'
import { vuex } from '@/components/mixin/vuex.js'
import { mapService } from '@/services/map/mapService.js'
import { fromLonLat } from 'ol/proj'
import { Vector as VectorLayer, Image as ImageLayer } from 'ol/layer.js';
import { Vector as VectorSource, ImageArcGISRest } from 'ol/source.js';
import { Style, Icon } from 'ol/style.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import proj4 from 'proj4';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faSpinner);

export default {
  name: 'LocatorTool',
  mixins: [vuex, draggableDiv],
  data() {
    return {
      map: null,
      markerLayer: null,
      sections: {
        coords: true,
        regional: false
      },
      activeTab: 'decimal',
      coords: {
        decimal: {
          lat: null,
          lon: null
        },
        utm: {
          x: null,
          y: null,
          zona: 19,
          hemisferio: 'S' // 'N' o 'S'
        },
        gms: {
          lat: { g: null, m: null, s: null, h: 'S' },
          lon: { g: null, m: null, s: null, h: 'O' }
        }
      },
      regional: {
        baseUrl: 'https://10.213.19.69:6443/arcgis/rest/services/SIIE/DPAHerramietaLocalizadorGeo/MapServer',
        regions: [],
        provinces: [],
        communes: [],
        entities: [],
        selected: {
          region: null,
          province: null,
          commune: null,
          entity: null
        },
        loading: {
          regions: false,
          provinces: false,
          communes: false,
          entities: false
        }
      }
    }
  },
  computed: {
    isActive() {
      return this.mapToolValues('locator').active && !this.isMobile
    }
  },
  methods: {
    toggleSection(section) {
      this.sections[section] = !this.sections[section];
      // Si activamos coordenadas, quitar capa regional
      if (section === 'coords' && this.sections.coords) {
        this.removeRegionalLayer();
      }
    },
    exitLocator() {
      this.removeMarker();
      this.removeRegionalLayer();
      this.selectMapTool('locator', false)
    },
    removeMarker() {
      if (this.map && this.markerLayer) {
        this.map.removeLayer(this.markerLayer);
        this.markerLayer = null;
      }
    },
    removeRegionalLayer() {
      if (this.map) {
        const layerIdTag = `locator_regional_layer`;
        const layers = this.map.getLayers().getArray();
        const layer = layers.find(l => l.get('id') === layerIdTag);
        if (layer) this.map.removeLayer(layer);
      }
    },
    applyLocalization(lon, lat) {
      if (!this.map) this.map = mapService.get();
      const pos = fromLonLat([parseFloat(lon), parseFloat(lat)]);

      // 1. Eliminar marcador anterior si existe
      this.removeMarker();

      // 2. Crear nuevo marcador (Punto Verde)
      const iconFeature = new Feature({
        geometry: new Point(pos),
      });

      const iconStyle = new Style({
        image: new Icon({
          anchor: [0.5, 1],
          src: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
          scale: 0.5,
          crossOrigin: 'anonymous'
        })
      });

      iconFeature.setStyle(iconStyle);

      this.markerLayer = new VectorLayer({
        source: new VectorSource({
          features: [iconFeature]
        }),
        zIndex: 2000
      });

      this.map.addLayer(this.markerLayer);

      // 3. Animar vista
      this.map.getView().animate({
        center: pos,
        zoom: 15,
        duration: 1000
      });
    },
    localizeDecimal() {
      const { lat, lon } = this.coords.decimal;
      if (lat !== null && lon !== null) {
        this.applyLocalization(lon, lat);
      } else {
        alert("Por favor ingrese latitud y longitud válidas");
      }
    },
    localizeUtm() {
      const { x, y, zona, hemisferio } = this.coords.utm;
      if (x && y && zona) {
        try {
          const utmStr = `+proj=utm +zone=${zona}${hemisferio === 'S' ? ' +south' : ''} +datum=WGS84 +units=m +no_defs`;
          const [lon, lat] = proj4(utmStr, 'WGS84', [parseFloat(x), parseFloat(y)]);
          this.applyLocalization(lon, lat);
        } catch (e) {
          alert("Error en la conversión de coordenadas UTM. Verifique los datos.");
          console.error(e);
        }
      } else {
        alert("Por favor complete todos los campos de UTM");
      }
    },
    localizeGms() {
      const { lat, lon } = this.coords.gms;
      
      const toDecimal = (g, m, s, h) => {
        let dec = parseFloat(g || 0) + parseFloat(m || 0) / 60 + parseFloat(s || 0) / 3600;
        if (h === 'S' || h === 'O') dec *= -1;
        return dec;
      };

      if (lat.g !== null && lon.g !== null) {
        const latDec = toDecimal(lat.g, lat.m, lat.s, lat.h);
        const lonDec = toDecimal(lon.g, lon.m, lon.s, lon.h);
        this.applyLocalization(lonDec, latDec);
      } else {
        alert("Por favor ingrese al menos los grados de latitud y longitud");
      }
    },

    // REGIONAL METHODS
    async fetchRegions() {
      this.regional.loading.regions = true;
      try {
        const params = new URLSearchParams({
          where: '1=1',
          outFields: 'nom_reg,cine_reg',
          orderByFields: 'nom_reg',
          f: 'json',
          returnGeometry: 'false'
        });
        const response = await fetch(`${this.regional.baseUrl}/1/query?${params.toString()}`);
        const data = await response.json();
        if (data.features) {
          this.regional.regions = data.features.map(f => f.attributes);
        } else {
          console.warn("No regions found or error in response:", data);
        }
      } catch (e) {
        console.error("Error fetching regions:", e);
      } finally {
        this.regional.loading.regions = false;
      }
    },

    async onRegionChange() {
      this.regional.selected.province = null;
      this.regional.selected.commune = null;
      this.regional.selected.entity = null;
      this.regional.provinces = [];
      this.regional.communes = [];
      this.regional.entities = [];

      if (!this.regional.selected.region) return;

      this.regional.loading.provinces = true;
      try {
        const params = new URLSearchParams({
          where: `cine_reg = '${this.regional.selected.region}'`,
          outFields: 'nom_prov,cine_prov',
          orderByFields: 'nom_prov',
          f: 'json',
          returnGeometry: 'false'
        });
        const response = await fetch(`${this.regional.baseUrl}/2/query?${params.toString()}`);
        const data = await response.json();
        if (data.features) {
          this.regional.provinces = data.features.map(f => f.attributes);
        }
      } catch (e) {
        console.error("Error fetching provinces:", e);
      } finally {
        this.regional.loading.provinces = false;
      }
    },

    async onProvinceChange() {
      this.regional.selected.commune = null;
      this.regional.selected.entity = null;
      this.regional.communes = [];
      this.regional.entities = [];

      if (!this.regional.selected.province) return;

      this.regional.loading.communes = true;
      try {
        const params = new URLSearchParams({
          where: `cine_prov = '${this.regional.selected.province}'`,
          outFields: 'nom_com,cine_com',
          orderByFields: 'nom_com',
          f: 'json',
          returnGeometry: 'false'
        });
        const response = await fetch(`${this.regional.baseUrl}/3/query?${params.toString()}`);
        const data = await response.json();
        if (data.features) {
          this.regional.communes = data.features.map(f => f.attributes);
        }
      } catch (e) {
        console.error("Error fetching communes:", e);
      } finally {
        this.regional.loading.communes = false;
      }
    },

    async onCommuneChange() {
      this.regional.selected.entity = null;
      this.regional.entities = [];

      if (!this.regional.selected.commune) return;

      this.regional.loading.entities = true;
      try {
        const params = new URLSearchParams({
          where: `cine_com = '${this.regional.selected.commune}'`,
          outFields: 'nom_ent,objectid_1',
          orderByFields: 'nom_ent',
          f: 'json',
          returnGeometry: 'false'
        });
        const response = await fetch(`${this.regional.baseUrl}/0/query?${params.toString()}`);
        const data = await response.json();
        this.regional.entities = data.features.map(f => f.attributes);
      } catch (e) {
        console.error("Error fetching entities:", e);
      } finally {
        this.regional.loading.entities = false;
      }
    },

    async goToRegional(layerId, value, field) {
      if (!value) return;
      try {
        const isNumeric = field.toLowerCase().includes('objectid') || typeof value === 'number';
        const whereClause = isNumeric ? `${field} = ${value}` : `${field} = '${value}'`;
        
        const params = new URLSearchParams({
          where: whereClause,
          outSR: '4326',
          f: 'json',
          returnGeometry: 'true'
        });
        const response = await fetch(`${this.regional.baseUrl}/${layerId}/query?${params.toString()}`);
        const data = await response.json();
        
        if (data.features && data.features.length > 0) {
          const feature = data.features[0];
          this.zoomToArcGISFeature(feature);
          
          // --- MOSTRAR CAPA FILTRADA ---
          this.displayRegionalLayer(layerId, value, field);
        }
      } catch (e) {
        console.error("Error navigating regional:", e);
      }
    },

    displayRegionalLayer(layerId, value, field) {
      if (!this.map) this.map = mapService.get();
      
      this.removeRegionalLayer();
      
      const layerIdTag = `locator_regional_layer`;
      const layerDefs = {};
      const isNumeric = field.toLowerCase().includes('objectid') || typeof value === 'number';
      layerDefs[layerId] = isNumeric ? `${field} = ${value}` : `${field} = '${value}'`;
      
      const source = new ImageArcGISRest({
        url: this.regional.baseUrl,
        params: {
          'LAYERS': `show:${layerId}`,
          'LAYERDEFS': JSON.stringify(layerDefs)
        },
        ratio: 1,
        crossOrigin: 'anonymous'
      });
      
      const layer = new ImageLayer({
        source: source,
        zIndex: 5, // Bajo el marcador verde (zIndex 2000)
        opacity: 0.6
      });
      layer.set('id', layerIdTag);
      
      this.map.addLayer(layer);
    },

    zoomToArcGISFeature(feature) {
      if (!this.map) this.map = mapService.get();
      
      const geometry = feature.geometry;
      let center = null;
      
      if (geometry.rings) {
        // Es un polígono, obtener el bounding box
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        geometry.rings[0].forEach(p => {
          if (p[0] < minX) minX = p[0];
          if (p[1] < minY) minY = p[1];
          if (p[0] > maxX) maxX = p[0];
          if (p[1] > maxY) maxY = p[1];
        });
        
        center = [(minX + maxX) / 2, (minY + maxY) / 2];
        const extent = [minX, minY, maxX, maxY]; // En 4326
        
        // Transformar extent a 3857 para fit
        const minP = fromLonLat([minX, minY]);
        const maxP = fromLonLat([maxX, maxY]);
        
        this.map.getView().fit([minP[0], minP[1], maxP[0], maxP[1]], {
          duration: 1000,
          padding: [50, 50, 50, 50]
        });
      } else if (geometry.x && geometry.y) {
        center = [geometry.x, geometry.y];
        this.map.getView().animate({
          center: fromLonLat(center),
          zoom: 15,
          duration: 1000
        });
      }

      if (center) {
        this.applyLocalization(center[0], center[1]);
      }
    }
  },
  mounted() {
    this.makeDraggable("locatorID");
    this.map = mapService.get();
    this.fetchRegions();
  },
  beforeDestroy() {
    this.removeMarker();
    this.removeRegionalLayer();
  },
  watch: {
    isActive(val) {
      if (!val) {
        this.removeMarker();
        this.removeRegionalLayer();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.widgetContainer {
  width: 350px;
  background: white;
  z-index: 1005;
}

.locator-sections {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.section-container {
  background: #f9f9f9;
}

.section-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: #f1f1f1;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.95em;
  
  span {
    margin-right: 5px;
  }

  &:hover {
    background: #e5e5e5;
  }
}

.tabs-container {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #ddd;
  background: white;
}

.tab-item {
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #666;
  flex: 1;
  text-align: center;
  font-size: 0.9em;

  &.active {
    color: #006FB3;
    border-bottom: 3px solid #006FB3;
  }

  &:hover:not(.active) {
    background: #f0f0f0;
  }
}

.tab-pane-content {
  padding: 15px;
  background: white;
}

.input-row {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.input-group {
  flex: 1;
  display: flex;
  flex-direction: column;

  label {
    font-weight: bold;
    font-size: 0.85em;
    margin-bottom: 5px;
    text-align: left;
  }

  input {
    width: 100%;
    padding: 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.9em;
  }
}

.button-center {
  display: flex;
  justify-content: center;
}

.btn-localizar {
  min-width: 120px;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.hemisphere-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  
  label {
    font-size: 0.85em;
    font-weight: bold;
    margin-bottom: 0;
  }
}

.zona-input {
  max-width: 80px;
}

.gms-section {
  text-align: left;
}

.section-label {
  font-weight: bold;
  font-size: 0.85em;
  margin-bottom: 5px;
  display: block;
}

.gms-row {
  align-items: flex-end;
}

.input-group.mini {
  max-width: 70px;
}

.h-btn-group {
  .btn-xs {
    padding: 1px 5px;
    font-size: 0.7em;
    line-height: 1.2;
  }
}

.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
}

.placeholder-text {
  text-align: center;
  font-style: italic;
  color: #888;
  padding: 20px 0;
}

.regional-form {
  padding: 5px 0;
}

.regional-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  label {
    flex: 0 0 80px;
    font-size: 0.85em;
    font-weight: bold;
    color: #444;
    margin-right: 10px;
    text-align: left;
  }
}

.input-and-btn {
  flex: 1;
  display: flex;
  gap: 8px;
}

.custom-select-small {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  font-size: 0.9em;
  color: #333;
  outline: none;
  min-width: 0; // Evita que el select ensanche el contenedor

  &:focus {
    border-color: #006FB3;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #999;
  }
}

.btn-ir {
  padding: 6px 12px;
  font-size: 0.85em;
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 60px;
  justify-content: center;
}

.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 1rem; }
.mb-3 { margin-bottom: 1rem; }
.mr-2 { margin-right: 0.5rem; }
.ml-1 { margin-left: 0.25rem; }
.text-primary { color: #006FB3; }
.overflow-hidden { overflow: hidden; }
</style>
